
import { Component, Vue, Prop } from 'vue-property-decorator';

import formatNumber from '@/shared/filters/format-number';

@Component
export default class ListPayService extends Vue {
    @Prop({default: {}})
    private listPayAuthority: any;

    private eventEmit = {
        eventReloadOrder: 'eventReloadOrder',
        eventCheckALl: 'eventCheckALl'
    };

    private async viewDetail(payauthority: any) {
        const routeData = this.$router.resolve({ name: 'payauthority-detail', params: { id: payauthority.ID.toString() } });
        window.open(routeData.href, '_blank');
    }

    private transformNumb(value: number, format: string) {
        if (!(value > 0)) {
            return '';
        }
        return formatNumber(value, format);
    }
}
